import { React, useEffect, useState, useContext } from "react";
import { AuthContext } from "../context/authContext";
import { FetchContext } from "../context/FetchContext";
import { Row, Container, Spinner, Tabs, Tab } from "react-bootstrap";
import Invoice from "../components/Invoice";
import Accordion from "../components/Accordion"
import { useNavigate } from "react-router-dom";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { decompress } from 'compress-json'

const Invoices = () => {

    const auth = useContext(AuthContext);
    const cons = auth.authState.userInfo;
    const fetchContext = useContext(FetchContext);
    // const [cons, setCons] = useState()
    const [noRecords, setNoRecords] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const [refresh, setRefresh] = useState(true);
    const [invoice, setPorjObject] = useState([]);
    const [descripts, setDescripts] = useState([]);
    const [fixedFeeContracts, setFixedFeeContracts] = useState([]);
    const [workingInvoices, setWorkingInvoices] = useState([])
    const [filtworkingInvoices, setFiltWorkingInvoices] = useState([])
    const [lockedInvoices, setLockedInvoices] = useState([])
    const [filtlockedInvoices, setFiltLockedInvoices] = useState([])
    const [processedInvoices, setProcessedInvoices] = useState([])
    const [filtprocessedInvoices, setFiltProcessedInvoices] = useState([])
    const [sortField, setSortField] = useState('')
    const [sortDirection, setSortDirection] = useState('asc')
    const history = useNavigate();
    useEffect(() => {
        if (refresh) {
            setIsLoading(true);
            getProjects();

            descriptions();
            fetchFixedFeeContracts();
            onCall();
            setRefresh(false);

        }
    }, [isLoading, refresh]);
    // console.log(invoice)
    async function getProjects() {
        try {
            await fetchContext.authAxios.get("/getinvoices").then((res) => {

                if (res.data.message === 'Session Expired') {
                    auth.logout()

                }
                if (res.data.message === 'No Records') {
                    setIsLoading(false)
                    setNoRecords(true)
                }
                let decom = decompress(res.data)

                let startInvoices = decom
                let invCom = [];
                // let lineItems = [];
                // let locations = [];
                const invoices = startInvoices.forEach(inv => {

                    let invoiceData = inv.fieldData
                    // console.log(inv)
                    let lineItems = [];
                    let locations = [];
                    let payments = [];
                    (inv.portalData["ConsultInv | PaymentsCons_ConsInv"] || []).forEach((py, i) => {

                        // console.log(py)
                        let payData = {
                            datePaid: py["ConsultInv | PaymentsCons_ConsInv::DatePd"],
                            pay: py["ConsultInv | PaymentsCons_ConsInv::Pay"],
                            payType: py["ConsultInv | PaymentsCons_ConsInv::PayType"],
                        }
                        // console.log(liData)
                        payments.push(payData)
                        return payData
                    });
                    (inv.portalData["ConsultInv | ConsultInvItems"] || []).forEach((li, i) => {
                        // console.log(li["ConsultInv | ConsultInvItems::Price"].length)

                        let liData = {
                            quantity: li["ConsultInv | ConsultInvItems::Quantity"],
                            ProductType: li["ConsultInv | ConsultInvItems::ProductType"],
                            ProductDetail: li["ConsultInv | ConsultInvItems::ProductDetail"],
                            rate: li["ConsultInv | ConsultInvItems::Price"] !== '' ? parseFloat(li["ConsultInv | ConsultInvItems::Price"]).toFixed(2) : li["ConsultInv | ConsultInvItems::Price"],
                            unit: '',
                            amount: parseFloat(li["ConsultInv | ConsultInvItems::Quantity"] * li["ConsultInv | ConsultInvItems::Price"]).toFixed(2),
                            recordID: li.recordId,
                            base64Container: li["ConsultInv | ConsultInvItems::Base64Container"],
                            fileName: li["ConsultInv | ConsultInvItems::fileName"]
                        }
                        // console.log(liData)
                        lineItems.push(liData)
                        return liData
                    });
                    (inv.portalData["ConsultInv | ConsultInvLoc"] || []).forEach((lo, i) => {

                        // console.log(lo)
                        let loData = {
                            city: lo["ConsultInv | ConsultInvLoc::LocationCity"],
                            state: lo["ConsultInv | ConsultInvLoc::LocationState"],
                            recordID: lo.recordId
                        }
                        // console.log(loData)
                        locations.push(loData)

                    })
                    // console.log(locations)




                    let amountOwed = parseFloat(invoiceData["Amount Due Cons"]) || 0;
                    let amountPaid = parseFloat(invoiceData["Genesis_TotalPayments"]) || 0;
                    let outstandingBalance = parseFloat(invoiceData["Genesis_OutstandingBalance"]) || 0;

                    let combined = Object.assign(
                        Object.assign({}, invoiceData),
                        {
                            lineItems,
                            locations,
                            payments,
                            amountOwed,
                            amountPaid,
                            outstandingBalance,
                            consultantsAssignProjects: inv.portalData["ConsultInv | ConsultantsAssign_Projects"] || []
                        }
                    )


                    invCom.push(combined)
                })

                invCom.sort(function (a, b) {
                    return new Date(b.Invoice_Date) - new Date(a.Invoice_Date) || b.Invoice_Number - a.Invoice_Number;
                })
                setPorjObject(invCom)
               
                let workingInvoices = invCom.filter(invS => invS.Status === 'Working')
                let lockedInvoices = invCom.filter(invS => invS.Status === 'Finalized' || invS.Status === "Lock")
                let processedInvoices = invCom.filter(invS => invS.Status === 'Processed')
                // console.log("workingInvoices")
                setWorkingInvoices(workingInvoices)
                setLockedInvoices(lockedInvoices)
                setProcessedInvoices(processedInvoices)
                setFiltWorkingInvoices(workingInvoices)
                setFiltLockedInvoices(lockedInvoices)
                setFiltProcessedInvoices(processedInvoices)
                // setCons(authState.userInfo)
                setRefresh(false);
                setIsLoading(false)
          
                
            });

        } catch (error) {
            console.log(error);
            setIsLoading(false);
        }
        // console.log(invoice)
    }
    function onCall() {
        // console.log(invoice)
    }
    function sortInvoices(list, field, direction) {
        if (!field) return list;
        const sorted = [...list].sort((a, b) => {
            if (field === 'Company_Name') {
                let valA = (a.Company_Name || '').toLowerCase();
                let valB = (b.Company_Name || '').toLowerCase();
                return direction === 'asc' ? valA.localeCompare(valB) : valB.localeCompare(valA);
            }
            if (field === 'Invoice_Date') {
                let valA = new Date(a.Invoice_Date || 0);
                let valB = new Date(b.Invoice_Date || 0);
                return direction === 'asc' ? valA - valB : valB - valA;
            }
            let valA = parseFloat(a[field]) || 0;
            let valB = parseFloat(b[field]) || 0;
            return direction === 'asc' ? valA - valB : valB - valA;
        });
        return sorted;
    }
    function handleSortClick(field) {
        const newDirection = (sortField === field && sortDirection === 'asc') ? 'desc' : 'asc';
        setSortField(field);
        setSortDirection(newDirection);
        setFiltWorkingInvoices(prev => sortInvoices(prev, field, newDirection));
        setFiltLockedInvoices(prev => sortInvoices(prev, field, newDirection));
        setFiltProcessedInvoices(prev => sortInvoices(prev, field, newDirection));
    }
    function invoicesearch(e, invs) {
        // console.log("prject searc")
        // console.log(e.target.name)
        // console.log(invs.Invoice_Date)
        var x = e.target.value.toString().toLowerCase();
        // console.log(x)
        if (e.target.name === 'drafts') {
            let t = workingInvoices.filter(proj => proj.ProjectName.toLowerCase().includes(x) || proj.Company_Name.toLowerCase().includes(x) || (proj.ConsultantInvoice || '').toString().toLowerCase().includes(x) || proj.Invoice_Date.toString().includes(x));
            setFiltWorkingInvoices(sortInvoices(t, sortField, sortDirection))

        }
        if (e.target.name === 'locked') {
            let t = lockedInvoices.filter(proj => proj.ProjectName.toLowerCase().includes(x) || proj.Company_Name.toLowerCase().includes(x) || (proj.ConsultantInvoice || '').toString().toLowerCase().includes(x) || proj.Invoice_Date.toString().includes(x));
            setFiltLockedInvoices(sortInvoices(t, sortField, sortDirection))


        }
        if (e.target.name === 'processed') {
            let t = processedInvoices.filter(proj => proj.ProjectName.toLowerCase().includes(x) || proj.Company_Name.toLowerCase().includes(x) || (proj.ConsultantInvoice || '').toString().toLowerCase().includes(x) || proj.Invoice_Date.toString().includes(x));
            setFiltProcessedInvoices(sortInvoices(t, sortField, sortDirection))

        }
    }
    async function descriptions() {
        // console.log("descriptions")
        // console.log(workingInvoices)
        try {
            await fetchContext.authAxios.get("/fmdescriptions").then((response) => {
                let data = response.data;

                // Get bill types from the first working invoice's consultantsAssignProjects
                let assignProjects = [];
                // console.log(workingInvoices)
                if (workingInvoices.length > 0 && Array.isArray(workingInvoices[0].consultantsAssignProjects)) {
                    // console.log(workingInvoices[0].consultantsAssignProjects)
                    assignProjects = workingInvoices[0].consultantsAssignProjects.map(
                        proj => proj['ConsultInv | ConsultantsAssign_Projects::BillType']
                    );
                    // console.log(assignProjects) 
                }

                // Only filter Consultant - Daily and Consultant - Hourly
               
         
                setDescripts(data);
                
                setIsLoading(false);
                return data;
            });
        } catch (error) {
            console.error("Error fetching descriptions:", error);
            return [];
        }
    }

    async function fetchFixedFeeContracts() {
        try {
            const response = await fetchContext.authAxios.get("/fixedfeecontracts");
            setFixedFeeContracts(response.data);
        } catch (error) {
            console.error("Error fetching fixed fee contracts:", error);
        }
    }

    return (
        <>
            <h1 className="text-center">Invoices</h1>
            <Row className="justify-content-center">
                {isLoading || invoice.length === undefined ? (
                    <>


                        <p className="pl-3 text-center">Gathering your invoices. This could take a moment.</p>
                        <Spinner animation="border" variant="danger" />


                    </>
                ) : (
                    noRecords ? (<>
                        <Container className="invoicesContainer">
                            <Row className="justify-content-center text-center">
                                <h5 className="text-center">There are no invoices. </h5>
                                <p>Go the the   <a href="/projects"> Projects Page</a> and select a project to create an invoice for.</p>
                                <FontAwesomeIcon icon={faCircleInfo} size="6x" />
                            </Row>
                        </Container>
                    </>) : (<Container className="invoicesContainer">
                        <Tabs
                            defaultActiveKey="drafts"
                            // id="justify-tab-example"
                            className="mb-3"
                            justify
                        >
                            {workingInvoices.length > 0 ? (
                                //    {  let filt = invoice.filter(inv => inv.Status === 'Working');}
                                <Tab eventKey="drafts" title="Drafts">
                                    <div className="text-center">
                                        <p className="mb-0 pb-0">Invoice Search</p> <br /> <input id="invoicesearch" name="drafts" onInput={e => invoicesearch(e, filtworkingInvoices)}
                                            className="mb-2 text-center inputsearch" placeholder="Project Name, Company, Date, Inv#" maxLength="95" type="text"></input>
                                    </div>
                                    <div className="text-center mb-2">
                                        <button type="button" className="btn btn-sm btn-outline-secondary me-1" onClick={() => handleSortClick('Company_Name')}>
                                            Company Name {sortField === 'Company_Name' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                        </button>
                                        <button type="button" className="btn btn-sm btn-outline-secondary me-1" onClick={() => handleSortClick('amountOwed')}>
                                            Invoice total {sortField === 'amountOwed' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                        </button>
                                        <button type="button" className="btn btn-sm btn-outline-secondary me-1" onClick={() => handleSortClick('amountPaid')}>
                                            Amount Paid {sortField === 'amountPaid' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                        </button>
                                        <button type="button" className="btn btn-sm btn-outline-secondary me-1" onClick={() => handleSortClick('outstandingBalance')}>
                                            Outstanding Balance {sortField === 'outstandingBalance' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                        </button>
                                        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => handleSortClick('Invoice_Date')}>
                                            Date Submitted {sortField === 'Invoice_Date' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                        </button>
                                    </div>
                                    {filtworkingInvoices.map((invoice) => (
                                        <Accordion
                                            key={invoice.Invoice_Number || invoice.recordID}
                                            name={[
                                                <span key={`company-${invoice.Invoice_Number || invoice.recordID}`} className="mb-0" style={{ width: 'max-content', display: 'inline-block' }}>
                                                    <strong>{invoice.Company_Name}</strong>
                                                </span>,
                                                <div key={`details-${invoice.Invoice_Number || invoice.recordID}`}>
                                                    <span className="mb-0">{invoice.ProjectName}</span>
                                                    <br />
                                                    <span className="mb-0">{invoice.Invoice_Date}</span>
                                                    <br />
                                                    <span className="mb-0">{invoice.ConsultantInvoice}</span>
                                                </div>
                                            ]}
                                            comp={<Invoice descripts={descripts} fixedFeeContracts={fixedFeeContracts} data={invoice} btnSelect={true} editable={true} cons={cons} setre={() => setRefresh(true)} />}
                                        />
                                    ))}
                                </Tab>

                            ) : (<Tab eventKey="drafts" title="Drafts">
                                <div className="text-center">
                                    <p className="mb-0 pb-0">There are currently no invoices saved as "Draft".</p> <br />
                                    <p>Go the the   <a href="/projects"> Projects Page</a> and select a project to create an invoice.</p>
                                </div></Tab>)}
                            {lockedInvoices.length > 0 ? (
                                //    {  let filt = invoice.filter(inv => inv.Status === 'Working');}
                                <Tab eventKey="submitted" title="Submitted">
                                    <div className="text-center">
                                        <p className="mb-0 pb-0">Invoice Search</p> <br /> <input id="invoicesearch" name="locked" onInput={e => invoicesearch(e, filtlockedInvoices)}
                                            className="mb-2 text-center inputsearch" placeholder="Project Name, Company, Date, Inv#" maxLength="95" type="text"></input>
                                    </div>
                                    <div className="text-center mb-2">
                                        <button type="button" className="btn btn-sm btn-outline-secondary me-1" onClick={() => handleSortClick('Company_Name')}>
                                            Company Name {sortField === 'Company_Name' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                        </button>
                                        <button type="button" className="btn btn-sm btn-outline-secondary me-1" onClick={() => handleSortClick('amountOwed')}>
                                            Invoice total {sortField === 'amountOwed' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                        </button>
                                        <button type="button" className="btn btn-sm btn-outline-secondary me-1" onClick={() => handleSortClick('amountPaid')}>
                                            Amount Paid {sortField === 'amountPaid' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                        </button>
                                        <button type="button" className="btn btn-sm btn-outline-secondary me-1" onClick={() => handleSortClick('outstandingBalance')}>
                                            Outstanding Balance {sortField === 'outstandingBalance' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                        </button>
                                        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => handleSortClick('Invoice_Date')}>
                                            Date Submitted {sortField === 'Invoice_Date' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                        </button>
                                    </div>
                                    {filtlockedInvoices.map((invoice) => (
                                        <Accordion
                                            key={invoice.Invoice_Number || invoice.recordID}
                                            pays={invoice.payments}
                                            payDue={invoice["Amount Due Cons"]}
                                            amountPaid={invoice["Genesis_TotalPayments"]}
                                            outstandingBalance={invoice["Genesis_OutstandingBalance"]}
                                            name={[
                                                <span key={`company-${invoice.Invoice_Number || invoice.recordID}`} className="mb-0" style={{ width: 'max-content', display: 'inline-block' }}>
                                                    <strong>{invoice.Company_Name}</strong>
                                                </span>,
                                                <div key={`details-${invoice.Invoice_Number || invoice.recordID}`}>
                                                    <span className="mb-0">{invoice.ProjectName}</span>
                                                    <br />
                                                    <span className="mb-0">{invoice.Invoice_Date}</span>
                                                    <br />
                                                    <span className="mb-0">{invoice.ConsultantInvoice}</span>
                                                </div>
                                            ]}
                                            status={invoice["Payment Status"]}
                                            comp={<Invoice key={invoice.Invoice_Number || invoice.recordID} data={invoice} cons={cons} btnSelect={false} editable={false} />}
                                        />
                                    ))}
                                </Tab>

                            ) : (<Tab eventKey="submitted" title="Submitted">
                                <div className="text-center">
                                    <p className="mb-0 pb-0">There are currently no invoices submitted.</p> <br />
                                    <p>Go the the   <a href="/projects"> Projects Page</a> and select a project to create an invoice.</p>
                                </div></Tab>)}
                            {processedInvoices.length > 0 ? (
                                //    {  let filt = invoice.filter(inv => inv.Status === 'Working');}
                                <Tab eventKey="processed" title="Processed">
                                    <div className="text-center">
                                        <p className="mb-0 pb-0">Invoice Search</p> <br /> <input id="invoicesearch" name="processed" onInput={e => invoicesearch(e, filtprocessedInvoices)}
                                            className="mb-2 text-center inputsearch" placeholder="Project Name, Company, Date, Inv#" maxLength="95" type="text"></input>
                                    </div>
                                    <div className="text-center mb-2">
                                        <button type="button" className="btn btn-sm btn-outline-secondary me-1" onClick={() => handleSortClick('Company_Name')}>
                                            Company Name {sortField === 'Company_Name' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                        </button>
                                        <button type="button" className="btn btn-sm btn-outline-secondary me-1" onClick={() => handleSortClick('amountOwed')}>
                                            Invoice total {sortField === 'amountOwed' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                        </button>
                                        <button type="button" className="btn btn-sm btn-outline-secondary me-1" onClick={() => handleSortClick('amountPaid')}>
                                            Amount Paid {sortField === 'amountPaid' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                        </button>
                                        <button type="button" className="btn btn-sm btn-outline-secondary me-1" onClick={() => handleSortClick('outstandingBalance')}>
                                            Outstanding Balance {sortField === 'outstandingBalance' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                        </button>
                                        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => handleSortClick('Invoice_Date')}>
                                            Date Submitted {sortField === 'Invoice_Date' ? (sortDirection === 'asc' ? '▲' : '▼') : ''}
                                        </button>
                                    </div>
                                    {filtprocessedInvoices.map((invoice) => (
                                        <Accordion
                                            key={invoice.Invoice_Number || invoice.recordID}
                                            pays={invoice.payments}
                                            payDue={invoice["Amount Due Cons"]}
                                            amountPaid={invoice["Genesis_TotalPayments"]}
                                            outstandingBalance={invoice["Genesis_OutstandingBalance"]}
                                            name={[
                                                <span key={`company-${invoice.Invoice_Number || invoice.recordID}`} className="mb-0" style={{ width: 'max-content', display: 'inline-block' }}>
                                                    <strong>{invoice.Company_Name}</strong>
                                                </span>,
                                                <div key={`details-${invoice.Invoice_Number || invoice.recordID}`}>
                                                    <span className="mb-0">{invoice.ProjectName}</span>
                                                    <br />
                                                    <span className="mb-0">{invoice.Invoice_Date}</span>
                                                    <br />
                                                    <span className="mb-0">{invoice.ConsultantInvoice}</span>
                                                </div>
                                            ]}
                                            status={invoice["Payment Status"]}
                                            comp={<Invoice key={invoice.Invoice_Number || invoice.recordID} cons={cons} data={invoice} btnSelect={false} editable={false} />}
                                        />
                                    ))}
                                </Tab>

                            ) : (<Tab eventKey="processed" title="Processed">
                                <div className="text-center">
                                    <p className="mb-0 pb-0">There are currently no processed invoices.</p> <br />
                                    <p>Go the the   <a href="/projects"> Projects Page</a> and select a project to create an invoice for.</p>
                                </div></Tab>)}


                        </Tabs>
                    </Container>)

                )}



            </Row>
        </>
    )
}

export default Invoices